import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Loader from 'components/Loader';

// modules
import { experiment } from 'helpers/Optimizely';

export default class PageHoc extends Component {
    componentDidMount() {
        const { match, fetchInitData, setListType, route } = this.props;

        // set the list type (onlineshoppingcart || onlineshoppinglist)
        setListType(route.listType);

        // Fetch translations and settings
        fetchInitData(match.params.country, match.params.language, route.listType);
    }

    render() {
        const { isLoading, route } = this.props;

        if (isLoading) return <Loader theme="animation" />;
        // render experiment variation container if set
        if (route.experiment) {
            const experimentName = route.experiment.name;
            const variations = route.experiment.variations;

            const variation = variations.find((variationEl) => {
                if (experiment(experimentName) === variationEl.name) return variationEl;
                return false;
            });

            if (variation) return <variation.container {...this.props} />;
        }

        // render original component
        return <route.container {...this.props}/>;
    }
}
PageHoc.propTypes = {
    isLoading: PropTypes.bool,
    fetchInitData: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    setListType: PropTypes.func.isRequired,
    route: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
};
